export default __webpack_public_path__ + "static/media/done.e2247fe6.svg";